module.exports = __webpack_public_path__ + "static/media/banner_forest_density_sat3.5c6ac874.jpg";